import React from 'react';
import s from '../AudienceInsights.module.css';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

type Datum = { name: string; value: number; color: string };
type Props = { data: Datum[] };

const AudienceGrowthDonut: React.FC<Props> = ({ data }) => {
    const total = data.reduce((sum, d) => sum + d.value, 0);
    const newFollowers = data.find((d) => d.name.toLowerCase().includes('new'))?.value || 0;
    const unfollows = data.find((d) => d.name.toLowerCase().includes('unfollow'))?.value || 0;
    const netGrowth = newFollowers - unfollows;

    const startAngle = 90;

    const yellowBase = [{ name: 'background', value: 1, color: '#FFC400' }];
    const purpleData = [
        { name: 'New followers', value: newFollowers, color: '#A053FF' },
        { name: 'rest', value: Math.max(0, total - newFollowers), color: 'transparent' },
    ];

    return (
        <div className={s.card}>
            <p className={s.cardTitle}>Net growth</p>
            <div className={s.chartWrap}>
                <ResponsiveContainer width="100%" height={220}>
                    <PieChart>
                        <Pie
                            data={yellowBase}
                            dataKey="value"
                            nameKey="name"
                            innerRadius={78}
                            outerRadius={110}
                            paddingAngle={0}
                            cornerRadius={14}
                            startAngle={startAngle}
                            endAngle={startAngle - 360}
                            stroke="none"
                            isAnimationActive={false}
                        >
                            {yellowBase.map((entry) => (
                                <Cell key={entry.name} fill={entry.color} />
                            ))}
                        </Pie>
                        <Pie
                            data={purpleData}
                            dataKey="value"
                            nameKey="name"
                            innerRadius={78}
                            outerRadius={110}
                            paddingAngle={0}
                            cornerRadius={14}
                            startAngle={startAngle}
                            endAngle={startAngle - 360}
                            stroke="none"
                            isAnimationActive={false}
                        >
                            {purpleData.map((entry) => (
                                <Cell key={entry.name} fill={entry.color} />
                            ))}
                        </Pie>
                    </PieChart>
                </ResponsiveContainer>
                <div className={s.centerLabel}>
                    <div className={s.centerTitle}>Net growth</div>
                    <div
                        className={s.centerValue}
                        style={{ color: netGrowth >= 0 ? '#10B981' : '#EF4444' }}
                    >
                        {netGrowth >= 0 ? '+' : ''}
                        {netGrowth}
                    </div>
                </div>
            </div>
            <div className={s.legendRow}>
                <div className={s.legendItem}>
                    <span className={s.dot} style={{ background: '#FFC400' }} />
                    Unfollows
                </div>
                <div className={s.legendItem}>
                    <span className={s.dot} style={{ background: '#A053FF' }} />
                    New followers
                </div>
            </div>
        </div>
    );
};

export default AudienceGrowthDonut;
